// src/i18n/index.js
import polyglotI18nProvider from 'ra-i18n-polyglot';
import { messages as englishMessages } from '../i18n/en';
import { messages as japaneseMessages } from '../i18n/ja';

const messages = {
  en: englishMessages,
  ja: japaneseMessages,
};

const i18nProvider = polyglotI18nProvider(
  // @ts-ignore
  (locale) => (messages[locale] || messages.en) as any,
  'ja', // Default locale
  [
    { locale: 'en', name: 'English' },
    { locale: 'ja', name: '日本語' },
  ],
);

export default i18nProvider;
